import { render } from "./PostFeedItem.vue?vue&type=template&id=71e10fe6&scoped=true"
import script from "./PostFeedItem.vue?vue&type=script&lang=js"
export * from "./PostFeedItem.vue?vue&type=script&lang=js"

import "./PostFeedItem.vue?vue&type=style&index=0&id=71e10fe6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71e10fe6"]])

export default __exports__